export default __webpack_public_path__ + "static/media/forgot.491b14a5.png";